import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Prospect, PaginatedResult, UpdateProspectPayload } from '@niko-crm/ui';

export const ProspectActions = createActionGroup({
  source: 'Prospects',
  events: {
    'Load Prospects': props<{ page: number; limit: number; filters?: Record<string, unknown>; sort?: { sortBy: string; sortDir: 'ASC' | 'DESC' } }>(),
    'Load Prospects Success': props<{ result: PaginatedResult<Prospect> }>(),
    'Load Prospects Failure': props<{ error: string }>(),
    'Load Prospects Grand Total': emptyProps(),
    'Load Prospects Grand Total Success': props<{ total: number }>(),
    'Load Prospects Grand Total Failure': props<{ error: string }>(),
    'Create Prospect': props<{ payload: Partial<Prospect> }>(),
    'Create Prospect Success': props<{ prospect: Prospect }>(),
    'Create Prospect Failure': props<{ error: string }>(),
    'Update Prospect': props<{ id: string; payload: UpdateProspectPayload }>(),
    'Update Prospect Success': props<{ prospect: Prospect }>(),
    'Update Prospect Failure': props<{ error: string }>(),
  },
});
